<template>
    <div class="footer">
        <div class="footwrap">
            <div class="top">
                <div class="logo_container">
                    <router-link to="/" class="logo"></router-link>
                </div>
                <div class="rights">כל הזכויות שמורות © המכרז השקוף</div>
            </div>
            <div class="bottom">
                <div class="menu">
                    <ol v-if="!is_mobile()">
                        <li id="tamalink" @click="scrollTo('tama38')">
                            <div >יתרונות מרכזיים</div>
                        </li>
                        <li @click="scrollTo('lawyers')">
                            <div>עורכי הדין</div>
                        </li>
                        <li @click="scrollTo('quotes')">
                            <div>עדויות דיירים</div>
                        </li>
                        <li @click="scrollTo('form_section')">
                            <div>איך זה עובד</div>
                        </li>
                        <li>
                            <router-link :to="{name: 'friends'}" >חברים במכרז השקוף</router-link>
                        </li>
                    </ol>
                </div>
            </div>
        </div>
        
    </div>
</template>

<style lang="scss" scoped>
.footer { 
    &{z-index: 9999; left: 0;background: #0C076B;border-bottom: 2px solid rgba(255, 255, 255, 0.10);color: white;display: flex;justify-content: center;}
    .footwrap {
        &{display: flex; flex-direction: column; gap: 16px; height: 100%;width: 80%; padding-block: 50px;}
        .top { display: flex; justify-content: space-between;align-items: center; 
            .logo_container {
                .logo { display: block; background-image: url("../../assets/logo2.svg"); background-position: center center; background-size: contain; background-repeat: no-repeat; height: 30px; width: 200px;}
            }
            .rights { font-size: 16px; font-family: var(--font2); }
        }
        .bottom { 
            .menu {  z-index: 9999999999; margin-bottom: 5px;
                ol {display: flex; flex-direction: column; gap: 6px; list-style: none; font-family: var(--font2);
                    li { cursor: pointer;
                        div, a {  transition: 0.3s ease scale;
                            // &:hover{ scale: 1.1; }
                        }
                        &, div { color: white;}
                    }
                }
            }
        }
        
    }
}
@media (max-width: 768px) {
    .top{
        display: flex;
        flex-direction: column;
        gap:15px;
    }
}

</style>